import {createAsyncThunk} from '@reduxjs/toolkit';
import {USER_SLICE_NAME} from '@jobseeker/common-core/constants';
import {userService} from '@jobseeker/common-core/services';

export const saveUserSettings = createAsyncThunk(
  `${USER_SLICE_NAME}/saveUserSettings`,
  async (settings: any, ThunkService) => {
    const data = await userService.saveUserSettings(settings);
    if (data?.error || data?.error?.code) {
      throw ThunkService.rejectWithValue(data);
    }
    return data;
  }
);

export const getUserSettings = createAsyncThunk(
  `${USER_SLICE_NAME}/getUserSettings`,
  async (_, ThunkService) => {
    const data = await userService.getUserSettings();
    if (data?.error || data?.error?.code) {
      throw ThunkService.rejectWithValue(data);
    }
    return data;
  }
);
